module.exports = __webpack_public_path__ + "img/logo-autograf.6cb1a421.png";